import { common_axios } from "../App";

//Loading..
export const saveDetailFuel = async (payload) => {
  try {
    const res = await common_axios.post("/fuel/v1/save-fuel-details", payload);
    return res;
  } catch (e) {}
};

/**
 * Fetches fuel types from the API.
 * @example
 * getFuelTypes().then(response => // console.log(response));
 * @returns {Promise<Object>} A promise that resolves to the response object containing fuel types.
 * @description
 *   - Utilizes common_axios to perform the GET request.
 *   - Handles errors silently.
 *   - Endpoint used is /fuel/v1/get-fuel-type.
 */
export const GetFuelDetails = async () => {
  try {
    const res = await common_axios.get("/fuel/v1/get-fuel-type");
    return res;
  } catch (e) {}
};

export const getFuelDetailsVehicle = async (payload) => {
  try {
    const res = await common_axios.post(
      "/fuel/v1/get/vehicle-details",
      payload
    );
    return res;
  } catch (e) {}
};

export const addFuelPurchase = async (payload) => {
  try {
    const res = await common_axios.post("/fuel/v1/save-fuel-purchase", payload);
    return res;
  } catch (e) {}
};

export const getFuelPurchase = async () => {
  try {
    const res = await common_axios.get("/fuel/v1/get-fuel-purchase");
    return res;
  } catch (e) {}
};

export const getRemainingQuantity = async () => {
  try {
    const res = await common_axios.get("/fuel/v1/get-remaining-quantity");
    return res;
  } catch (e) {}
};

export const getLastRefillService = async (payload) => {
  try {
    const res = await common_axios.post("/fuel/v1/get-last-refill", payload);
    return res;
  } catch (e) {}
};
